import React, { useState, useMemo, useRef } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import { DATA_SOURCE_NAME_MAP } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
// import ArrowdownText from '@/pages/intelligence/components/ArrowdownText';
import ChartTypeTab from '@/pages/intelligence/components/ChartsComponents/ChartTypeTab';
import useBarCharts from '@/pages/intelligence/components/Chart/hooks/useBarCharts';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';

// 每个榜单，组装好各类可视化需要的数据，传递给可视化统一组件
const Visualis: React.FC<any> = (props: any) => {
  const {
    chartType = ChartType.Bar,
    dateType = 'Month',
    metric,
    metricName,
    setMetric,
    imageType,
    barSeriesData,
    lineXAxisData, // x轴 label 数据
    lineSeriesData = [], // 折线 数据
    legendsCustomMade, // 图例
    yAxisFormatter, // y轴格式化函数
    splitNumber = 4, // y轴显示个数
    isxLabelDate = true, // x轴label默认展示日期
    legendStyle = '',
    isNodata,
    fetchParams,
    barOrPieData,
    barNameList,
    topChartsType,
    titleNow,
  } = props;
  const { data_source } = fetchParams;
  // console.log('VisualisVisualis,',props);

  const dataSources = data_source || ['appannie'];
  const cardRef = useRef(null);

  const [chartLoading, setChartLoading] = useState(true);

  const dataSourceNames = useMemo(() => {
    if (!Array.isArray(dataSources)) return [];
    return dataSources.map((item) => DATA_SOURCE_NAME_MAP[item]).filter((item) => item);
  }, [dataSources]);

  // 获取柱状图hooks
  const { barOption } = useBarCharts({
    seriesData: barSeriesData,
    setChartLoading,
    barOrPieData,
    titleNow: metricName,
    dataSourceEachers: dataSourceNames,
    barNameList,
    topChartsType,
    cardWidth: cardRef?.current?.clientWidth,
    startDate: fetchParams?.start_date,
    endDate: fetchParams?.end_date,
  });

  // 获取折线图hooks
  const { lineOption } = useLineCharts({
    lineXAxisData, // x轴 label 数据
    lineSeriesData, // 折线 数据
    legendsCustomMade, // 图例
    yAxisFormatter, // y轴格式化函数
    splitNumber, // y轴显示个数
    isxLabelDate, // x轴label默认展示日期
    dateType,
    legendStyle,
    topChartsType,
    imageType,
    titleNow,
    data_source,
  });

  const handleMetricChange = (value: string): void => {
    setMetric(value);
  };

  return (
    <>
      <div className="card-flex">
        <div className="card-title">
          <ChartTypeTab defaultValue={metric} selectType="RPD" sendSegment={handleMetricChange} />
          {/* <ArrowdownText isNew={true} sortedData={sortKeyName} order={fetchParams.order} /> */}
        </div>
      </div>

      <div className="card-line" ref={cardRef}>
        <ChartsIndex
          chartLoading={chartLoading}
          barOption={barOption}
          lineOption={lineOption}
          chartType={chartType}
          isNodata={isNodata}
          dataSourceNames={dataSourceNames}
        />
      </div>
    </>
  );
};

export default Visualis;
